import React from 'react';
import defaultPropTypes from '../utils/prop-types';
import FilterListItem from './filter-list-item';

var FilterList = function FilterList(props) {
  var ItemView = props.filterListItemView;
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.settings.Filters.length === 0 && null, props.settings.Filters.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "filter-list"
  }, /*#__PURE__*/React.createElement("button", {
    className: "close-button",
    onClick: function onClick(e) {
      props.onCloseFilterList(e);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "filter-list-title"
  }, props.settings.dictionary.filterListTitle), /*#__PURE__*/React.createElement("div", {
    className: "filter-list-filters"
  }, props.settings.Filters.map(function (filter, index) {
    return /*#__PURE__*/React.createElement(ItemView, Object.assign({
      key: "filterItem-".concat(filter.id),
      filter: filter,
      index: index
    }, props));
  }))));
};

export default FilterList;
FilterList.propTypes = {
  filterListItemView: defaultPropTypes.func,
  onCloseFilterList: defaultPropTypes.func,
  settings: defaultPropTypes.settings
};
FilterList.defaultProps = {
  filterListItemView: FilterListItem,
  onCloseFilterList: defaultPropTypes.defaultOnCloseFilterList,
  settings: defaultPropTypes.defaultSettings
};